// extracted by mini-css-extract-plugin
export default {"imageContainer":"PaintCategory_imageContainer__h++mw"};